module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-regular.bf67d9a.eot";